var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"layout",staticClass:"layout--page"},[_c('header-block',{ref:"header"}),_c('main',{ref:"main",staticClass:"page"},[_c('div',{staticClass:"page__container"},[_vm._t("default")],2)]),_c('footer-block',{ref:"footer"}),_c('app-notification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }